export const personalDataSecurity = {
    title: 'Обеспечение безопасности личных сведений',
    isBordered: true,
    blocks: [
        {
            type: 'text',
            value: 'Компания уделяет повышенное внимание информационной безопасности посетителей сайта, применяя технологии и процедуры, помогающие защитить их данные от кражи, модификации, возможного несанкционированного доступа, нелегального использования или разглашения.',
        },
        {
            type: 'text',
            value: 'Однако, Компания не может гарантировать безопасную передачу любой информации по открытым каналам. Для передачи конфиденциальной информации между пользователем и сайтом Компании используется безопасное SSL-соединение.',
        },
        {
            type: 'text',
            value: 'Рекомендуем Вам использовать только современные браузеры и производить своевременное их обновление.',
        },
    ],
};
